import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { getDualOccupantData, getStorage, setStorage } from 'src/utils/local-storage-versioning';
import store from 'src/store/store';
import { setDetails, setLoggedIn, setTokenDetails } from 'src/store/slices/user-slice';
import { routes } from 'src/constants/routes';
import { ErrorMessage } from 'src/shared/enum/ErrorMessage';

import { auth0, METADATA_ATTR_URL } from '../../auth/constants';

export const DualOccupantCallbackPage: FC = () => {
    const navigate = useNavigate();
    const dualOccupantData = getDualOccupantData();

    useEffect(() => {
        auth0.parseHash((err, authResult) => {
            if (err) {
                throw new Error(err.error);
            }

            if (authResult && authResult.idToken && authResult.idTokenPayload) {
                if (!dualOccupantData) throw new Error(ErrorMessage.AUTH0_LOGIN_ERROR);
                store.dispatch(setTokenDetails(authResult));
                store.dispatch(setLoggedIn(true));

                const userMetadata = authResult.idTokenPayload[METADATA_ATTR_URL];
                store.dispatch(setDetails(userMetadata));

                setStorage({
                    ...getStorage(),
                    auth0: {
                        access_token: authResult.accessToken ?? null,
                        id_token: authResult.idToken ?? null,
                        tokenExpired: false,
                    },
                });

                const queryParams = new URLSearchParams({
                    ref: dualOccupantData.vitaRef,
                    u: dualOccupantData.email,
                    pin: dualOccupantData.pin,
                });

                navigate(`${routes.occupant.details}?${queryParams?.toString()}`);
            }
        });
    });

    return null;
};
